import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    overallPoints: [],
    overallPointsLoading: false,
    overallMedals: [],
    overallMedalsLoading: false,
    current: [],
    currentLoading: false,
    currentEventBrackets: [],
    currentEventBracketsLoading: false
  },
  mutations: {
    setOverallPoints(state, payload) {
      state.overallPoints = payload;
    },
    setOverallPointsLoading(state, payload) {
      state.overallPointsLoading = payload;
    },
    setOverallMedals(state, payload) {
      state.overallMedals = payload;
    },
    setOverallMedalsLoading(state, payload) {
      state.overallMedalsLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setCurrentEventBrackets(state, payload) {
      state.currentEventBrackets = payload;
    },
    setCurrentEventBracketsLoading(state, payload) {
      state.currentEventBracketsLoading = payload;
    }
  },
  actions: {
    async overallPoints({ commit }, filter) {
      commit("setOverallPointsLoading", true);
      let response = await api.get("liveResults/overallPoints", {
        params: filter
      });
      commit("setOverallPoints", response.data);
      commit("setOverallPointsLoading", false);
    },
    async overallMedals({ commit }, filter) {
      commit("setOverallMedalsLoading", true);
      let response = await api.get("liveResults/overallMedals", {
        params: filter
      });
      commit("setOverallMedals", response.data);
      commit("setOverallMedalsLoading", false);
    },
    async eventBrackets({ commit }, filter) {
      commit("setCurrentEventBracketsLoading", true);
      let response = await api.get("liveResults/events/brackets", {
        params: filter
      });
      commit("setCurrentEventBrackets", response.data);
      commit("setCurrentEventBracketsLoading", false);
    }
  },
  getters: {
    overallPoints(state) {
      return state.overallPoints.sort((a, b) => {
        return b.points - a.points;
      });
    },
    overallPointsLoading(state) {
      return state.overallPointsLoading;
    },
    overallMedals(state) {
      return state.overallMedals.sort((a, b) => {
        return b.medals - a.medals;
      });
    },
    overallMedalsLoading(state) {
      return state.overallMedalsLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    currentEventBrackets(state) {
      return state.currentEventBrackets;
    },
    currentEventBracketsLoading(state) {
      return state.currentEventBracketsLoading;
    }
  }
};
